import { Ability } from '@casl/ability'
import encryptionService from '@/services/encryption.service'
import { initialAbility } from './config'

const encyptedPermissions = localStorage.getItem('userAbility')
const existingAbility = encyptedPermissions ? JSON.parse(encryptionService.decrypt(encyptedPermissions)) : null

export default new Ability(existingAbility || initialAbility)
